<template>
  <div class="term-and-conditions">
    <section class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="section-title">
              {{ $t('label.title.termAndConditions') }}
            </h1>
          </div>
          <template v-if="$i18n.locale === 'en'">
            <term-english />
          </template>
          <template v-else>
            <term-khmer />
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TermEnglish from '../components/documents/term/TermEnglish'
import TermKhmer from '../components/documents/term/TermKhmer'

export default {
  name: 'TermAndConditions',
  metaInfo: {
    title: 'Term and conditions',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Cash hero website' }
    ]
  },
  components: { TermEnglish, TermKhmer }
}
</script>

<style scoped>
  h4 {
    margin: 20px 0;
  }
</style>
